module.exports = __webpack_public_path__ + "img/study.67d44e65.png";